/**
 * Labstep
 *
 * @module components/ResearchArea/Manager
 * @desc Manage research areas
 */

import { useHasAccess } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { EntityListToggle as ToggleEntityList } from 'labstep-web/components/Entity/ListToggle';
import { ResearchAreaItemToggleContainer } from 'labstep-web/components/ResearchArea/Item';
import type { ResearchArea } from 'labstep-web/models/research-area.model';
import type React from 'react';
import type { IResearchAreaManagerProps } from './types';

export const ResearchAreaManager: React.FC<
  IResearchAreaManagerProps
> = ({ user }) => {
  const canEdit = useHasAccess(user.entityName, user.id, Action.edit);
  return (
    <div id="research-area-card">
      <ToggleEntityList
        extraSearchParams={{ is_verified: true }}
        creatable
        createKey="label"
        actionMessageIcon="graduation cap"
        parent={user.profile}
        entityName="research_area"
        list={({ entities }: { entities: ResearchArea[] }) => (
          <div>
            {entities.map((entity) => (
              <ResearchAreaItemToggleContainer
                key={entity.id}
                profile={user.profile}
                researchArea={entity}
                remove={canEdit}
              />
            ))}
          </div>
        )}
      />
    </div>
  );
};
